/** @jsxImportSource @emotion/react */

import UI from "@mile-meeting/mile-ui";
import { css } from "@emotion/react";
import { useLocation } from "react-router-dom";
import { generateGoogleAccessToken } from "apis/auth/google";
import { useEffect, useState } from "react";
import { loginWithGoogle } from "apis/auth/login";
import { encrypt } from "utils/crypto";
import AlertModal from "uis/modal/alert-modal";
import { LoadingModal } from "uis/modal";

const GoogleRedirect = () => {
  const location = useLocation();
  const code = new URLSearchParams(location.search).get("code");
  const page = location.pathname.split("/")[3];
  const [openAlertModal, setOpenAlertModal] = useState<boolean>(false);

  const getGoogleAccessToken = async (redirectUri: string) => {
    if (code) {
      const { success, googleAccessToken, googleRefreshToken, error } = await generateGoogleAccessToken(
        code,
        redirectUri,
      );

      try {
        if (window.opener) {
          if (success && googleAccessToken) {
            window.opener.postMessage({ success: true, googleAccessToken, googleRefreshToken }, "*");
          } else {
            window.opener.postMessage({ success: false, error: error }, "*");
          }
        } else {
        }
      } catch (err) {
        console.error(err);
      } finally {
        window.close();
      }
    }
  };

  const googleLogin = async (redirectUri: string) => {
    if (code) {
      localStorage.clear();
      sessionStorage.clear();
      const res = await loginWithGoogle(code, redirectUri);
      if (res?.success && res?.accessToken) {
        localStorage.setItem("access-token", `${encrypt(res.accessToken)}`);
        setTimeout(() => {
          window.location.href = "/workspace/list";
        }, 100);
      } else {
        setOpenAlertModal(true);
      }
    }
  };

  useEffect(() => {
    if (page.includes("sign-up")) {
      getGoogleAccessToken(`${process.env.REACT_APP_WEB_URL}/google/redirect/sign-up`);
    } else if (page.includes("member-list")) {
      getGoogleAccessToken(`${process.env.REACT_APP_WEB_URL}/google/redirect/member-list`);
    } else if (page.includes("login")) {
      googleLogin(`${process.env.REACT_APP_WEB_URL}/google/redirect/login`);
    }
  }, []);

  return (
    <div>
      {!page.includes("login") && <LoadingModal title={""} modalIsOpen={true} />}
      {page.includes("login") && <LoadingModal title={"워크스페이스 목록을 조회 중입니다."} modalIsOpen={true} />}
      <AlertModal
        title={"가입되지 않은 구글 계정입니다."}
        btnTitle="Mile 회원가입 하기"
        onChange={() => {
          window.location.href = "/sign-up";
        }}
        modalIsOpen={openAlertModal}
        closeModal={() => {
          setOpenAlertModal(false);
          window.location.href = "/login";
        }}
        zIndex={1011}
      />
    </div>
  );
};

export default GoogleRedirect;
